import { useCallback, useState } from 'react';
import { type Node, useOnSelectionChange } from '@xyflow/react';

/**
 * Tracks whether multiple nodes are currently selected.
 * @returns true if multiple nodes are selected
 */
export const useMultipleNodesSelected = () => {
  const [multipleNodesSelected, setMultipleNodesSelected] = useState(false);

  const onSelectionChange = useCallback(
    ({ nodes }: { nodes: Node[] }) => {
      if (nodes.length > 1) {
        setMultipleNodesSelected(true);
      } else {
        setMultipleNodesSelected(false);
      }
    },
    [setMultipleNodesSelected],
  );
  useOnSelectionChange({ onChange: onSelectionChange });

  return multipleNodesSelected;
};
